type Output = {
  packageId: number;
  packageName?: string;
}[];

export default function parsePackageOptions(packageId: string | number): Output {
  if (!Number.isNaN(Number(packageId))) {
    return [{
      packageId: Number(packageId),
      packageName: undefined,
    }];
  }

  const packages = String(packageId).split(',');

  return packages.map((p) => {
    if (!p.includes('=')) {
      return {
        packageId: Number(p),
        packageName: undefined,
      };
    }

    const [id, name] = p.split('=');

    return {
      packageId: Number(id),
      packageName: name.trim(),
    };
  });
}
